<script lang="ts">
	import { createDialog } from 'svelte-headlessui';
	import Transition from 'svelte-transition';
	import {
		PROJECT_PACK_GENERATIONS,
		STARTER_DAILY_CANVAS_IMAGES,
		STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES
	} from '$lib/constants';
	export let usageExceededErrorDetail: string;
	export let generationTool: 'canvas' | 'referenceToTexture' = 'canvas';

	$: dailyFreeGenerations =
		generationTool === 'referenceToTexture'
			? STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES
			: STARTER_DAILY_CANVAS_IMAGES;

	const dialog = createDialog({ label: 'Usage Exceeded' });

	export function openDialog() {
		dialog.open();
	}

	export function closeDialog() {
		dialog.close();
	}
</script>

<div class={`fixed w-screen h-screen inset-0 ${$dialog.expanded ? 'z-50' : 'z-[-10]'}`}>
	<Transition show={$dialog.expanded}>
		<button
			aria-label="Close dialog"
			class="w-full h-full bg-zinc-900 bg-opacity-25 cursor-default focus:outline-none"
			on:click={dialog.close}
		></button>
		<div
			class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[28rem] h-fit p-10 flex flex-col justify-start items-start text-zinc-200 bg-zinc-900 rounded-tr rounded-br border border-zinc-800 shadow-md z-50 text-sm"
			use:dialog.modal
		>
			<button
				aria-label="Close dialog"
				class="absolute w-8 h-8 top-2 right-2 rounded-2xl hover:bg-zinc-700 text-zinc-500 hover:text-zinc-300 text-md focus:outline-none"
				on:click={dialog.close}
			>
				<i class="fa-solid fa-times text-md"></i>
			</button>
			{#if usageExceededErrorDetail == 'Exceeded Free Texture Canvas usage limit.'}
				<div class="text-lg">
					You've used all {STARTER_DAILY_CANVAS_IMAGES} free daily Texture Canvas generations.
				</div>
				<div class="h-4"></div>
				<div>To get more generations:</div>
				<div class="h-2"></div>
				<ul class="list-disc list-inside text-sm text-zinc-300">
					<li>Buy a Project Pack ({PROJECT_PACK_GENERATIONS} generations for $15)</li>
					<li>Upgrade to Pro for full access</li>
					<li>
						Or check back tomorrow for {STARTER_DAILY_CANVAS_IMAGES} more free Texture Canvas generations
					</li>
				</ul>
			{:else if usageExceededErrorDetail == 'Exceeded Free Reference to Texture usage limit.'}
				<div class="text-lg">
					You've used all {STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES} free daily Reference to Texture
					generations.
				</div>
				<div class="h-4"></div>
				<div>To get more generations:</div>
				<div class="h-2"></div>
				<ul class="list-disc list-inside text-sm text-zinc-300">
					<li>Buy a Project Pack ({PROJECT_PACK_GENERATIONS} generations for $15)</li>
					<li>Upgrade to Pro for full access</li>
					<li>
						Or check back tomorrow for {STARTER_DAILY_REFERENCE_TO_TEXTURE_IMAGES} more free Reference
						to Texture generations
					</li>
				</ul>
			{:else if usageExceededErrorDetail == 'Exceeded Project usage limit.'}
				<div class="text-lg">You've used all of your generations.</div>
				<div class="h-4"></div>
				<div>To get more generations:</div>
				<div class="h-2"></div>
				<ul class="list-disc list-inside text-sm text-zinc-300">
					<li>Buy another Project Pack ({PROJECT_PACK_GENERATIONS} generations for $15)</li>
					<li>Upgrade to Pro for full access</li>
					<li>Or check back tomorrow for {dailyFreeGenerations} free daily generations</li>
				</ul>
			{:else if usageExceededErrorDetail == 'Exceeded Free 3D model usage limit.'}
				<div class="text-lg">You've reached the Free plan's limit for 3D generations.</div>
				<div class="h-4"></div>
				<div>For full access to the 3D pipeline, try Pro.</div>
			{:else if usageExceededErrorDetail == 'Exceeded Pro Halcyon usage limit.'}
				<div class="text-lg">Wow, you sure you Iliad a lot.</div>
				<div class="h-4"></div>
				<div>Try emailing support@iliad.ai if you need help.</div>
			{:else if usageExceededErrorDetail == 'Exceeded Pro Aeolian usage limit.'}
				<div class="text-lg">
					You've reached the Pro plan's monthly limit for Aeolian generations.
				</div>
				<div class="h-4"></div>
				<div>Try emailing support@iliad.ai if you need increased limits.</div>
			{:else if usageExceededErrorDetail == 'Exceeded Pro 3D model usage limit.'}
				<div class="text-lg">You've reached the Pro plan's monthly limit for 3D generations.</div>
				<div class="h-4"></div>
				<div>Try emailing support@iliad.ai if you need increased limits.</div>
			{:else if usageExceededErrorDetail == 'Exceeded Pro GPT usage limit.'}
				<div class="text-lg">You've reached the Pro plan's monthly limit for GPT generations.</div>
				<div class="h-4"></div>
				<div>Try emailing support@iliad.ai if you need increased limits.</div>
			{:else}
				<div class="text-lg">Usage limits exceeded for the current plan.</div>
			{/if}
			<div class="h-6"></div>
			<a
				class="w-full py-4 flex flex-row justify-center items-center text-sm font-semibold rounded shadow-lg text-zinc-900 bg-cyan-300 hover:bg-cyan-200"
				href="plan">Get more generations</a
			>
		</div>
	</Transition>
</div>
